/* ==========================================================================
   CUSTOM THEME SCRIPT
   File goes in: Shopify Admin → Online Store → Themes → Edit code → Assets
   Save as: custom-theme.js
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Scroll reveal: fades/slides in any element with class "rm-reveal" ---
  var revealEls = document.querySelectorAll('.rm-reveal');
  if ('IntersectionObserver' in window && revealEls.length && !prefersReduced) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // --- Hero background parallax on scroll ---
  if (!prefersReduced) {
    var heroBg = document.querySelector('.rm-hero__bg');
    if (heroBg) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            var offset = window.scrollY;
            heroBg.style.transform = 'translateY(' + offset * 0.25 + 'px) scale(1.05)';
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  }

  // --- Menu page: click a pill -> force a smooth scroll down to its section ---
  var menuPills = document.querySelectorAll('[data-rm-menu-pill]');
  var menuSections = document.querySelectorAll('[data-rm-menu-section]');

  function scrollToMenuSection(targetEl, animate) {
    var stickyBar = document.querySelector('.rm-menu__slider');
    var offset = stickyBar ? stickyBar.getBoundingClientRect().height + 24 : 24;
    var targetTop = targetEl.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top: targetTop,
      behavior: animate && !prefersReduced ? 'smooth' : 'auto'
    });
    var pill = document.querySelector('[data-target="' + targetEl.id + '"]');
    if (pill) {
      menuPills.forEach(function (p) {
        p.classList.remove('is-active');
      });
      pill.classList.add('is-active');
    }
  }

  if (menuPills.length && menuSections.length) {
    menuPills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        var targetId = pill.getAttribute('data-target');
        var targetEl = document.getElementById(targetId);
        if (!targetEl) return;
        e.preventDefault();
        scrollToMenuSection(targetEl, true);
        if (history.pushState) {
          history.pushState(null, '', '#' + targetId);
        }
      });
    });
  }

  // --- Arriving from another page (e.g. the home category grid) with a
  //     #rm-cat-... hash: don't just land there, visibly scroll down to it ---
  if (menuSections.length && window.location.hash) {
    var hashTarget = document.getElementById(window.location.hash.substring(1));
    if (hashTarget && hashTarget.hasAttribute('data-rm-menu-section')) {
      window.scrollTo(0, 0);
      window.setTimeout(function () {
        scrollToMenuSection(hashTarget, true);
      }, 150);
    }
  }

  // --- Menu page: highlight active category pill while scrolling ---
  if (menuPills.length && menuSections.length && 'IntersectionObserver' in window) {
    var menuObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var pill = document.querySelector('[data-target="' + entry.target.id + '"]');
          if (!pill) return;
          menuPills.forEach(function (p) {
            p.classList.remove('is-active');
          });
          pill.classList.add('is-active');
          pill.scrollIntoView({
            block: 'nearest',
            inline: 'center',
            behavior: prefersReduced ? 'auto' : 'smooth'
          });
        });
      },
      { rootMargin: '-35% 0px -55% 0px', threshold: 0 }
    );
    menuSections.forEach(function (section) {
      menuObserver.observe(section);
    });
  }

  // --- Product page: update price when a different variant is selected ---
  function formatMoney(cents, format) {
    cents = parseInt(cents, 10) || 0;
    format = format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }

    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }
    return match ? format.replace(match[0], value) : value;
  }

  var productSection = document.querySelector('[data-money-format]');
  if (productSection) {
    var moneyFormat = productSection.getAttribute('data-money-format') || '${{amount}}';
    var variantSelect = productSection.querySelector('[data-product-variant-select]');
    var priceEl = productSection.querySelector('[data-product-price]');
    var compareEl = productSection.querySelector('[data-product-price-compare]');
    var submitBtn = productSection.querySelector('[data-product-submit]');
    var submitText = productSection.querySelector('[data-product-submit-text]');

    function updateVariantUI(option) {
      if (!option) return;
      var price = option.getAttribute('data-price');
      var compareAt = parseInt(option.getAttribute('data-compare-at-price'), 10) || 0;
      var available = option.getAttribute('data-available') === 'true';

      if (priceEl) {
        priceEl.textContent = formatMoney(price, moneyFormat);
      }
      if (compareEl) {
        if (compareAt > parseInt(price, 10)) {
          compareEl.textContent = formatMoney(compareAt, moneyFormat);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !available;
      }
      if (submitText) {
        submitText.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        updateVariantUI(variantSelect.options[variantSelect.selectedIndex]);
      });
    }
  }

  // --- Photo slider: square peek-carousel, auto-advance + click-next-to-advance ---
  var sliders = document.querySelectorAll('[data-rm-slider]');
  sliders.forEach(function (slider) {
    var list = slider.querySelector('[data-rm-slider-list]');
    var slides = slider.querySelectorAll('[data-rm-slide]');
    if (!list || slides.length < 2) return;

    var current = 0;
    var interval = parseInt(slider.getAttribute('data-interval'), 10) || 5000;
    var timer = null;

    function update() {
      var gap = parseFloat(getComputedStyle(list).gap) || 0;
      var slideWidth = slides[0].getBoundingClientRect().width;
      var offset = current * (slideWidth + gap);
      list.style.transform = 'translateX(-' + offset + 'px)';
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
      });
    }

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      update();
    }

    function start() {
      if (prefersReduced) return;
      stop();
      timer = window.setInterval(function () {
        goTo(current + 1);
      }, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function () {
        if (i !== current) {
          goTo(i);
          start();
        }
      });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    window.addEventListener('resize', update);

    update();
    start();
  });
});
